import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Lock: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='m510 270h-30v-37.5c0-45.15-40.37-81.88-90-81.88s-90 36.73-90 81.88v37.5h-30v-37.5c0-61.69 53.83-111.88 120-111.88s120 50.19 120 111.88z' />
    <path d='m390 535c-41.36 0-75-33.65-75-75s33.64-75 75-75 75 33.65 75 75-33.64 75-75 75zm0-120c-24.81 0-45 20.19-45 45s20.19 45 45 45 45-20.19 45-45-20.19-45-45-45z' />
    <path d='m375 525h30v55h-30z' />
    <path d='m630 660h-480v-360h405c41.36 0 75 33.65 75 75zm-450-30h420v-255c0-24.81-20.19-45-45-45h-375z' />
  </IconBase>
));

Lock.displayName = 'Lock';

export default Lock;
